import { render, staticRenderFns } from "./CourseOverviewIndex.vue?vue&type=template&id=671dfe85&"
import script from "./CourseOverviewIndex.vue?vue&type=script&lang=js&"
export * from "./CourseOverviewIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports